import { render, staticRenderFns } from "./mainbusiness.vue?vue&type=template&id=27624ff8&scoped=true&"
import script from "./mainbusiness.vue?vue&type=script&lang=js&"
export * from "./mainbusiness.vue?vue&type=script&lang=js&"
import style0 from "./mainbusiness.vue?vue&type=style&index=0&id=27624ff8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27624ff8",
  null
  
)

export default component.exports